// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-date-picker__extended[data-v-ea0e4df8] .custom-datetime-picker {\n  position: absolute !important;\n}\n.redirect__action[data-v-ea0e4df8] {\n  color: #5bb486;\n  cursor: pointer;\n}\n.alert-danger-custom[data-v-ea0e4df8] {\n  color: #ec6662;\n  background-color: #fcefef;\n  border-color: #f4b5b3;\n}", ""]);
// Exports
module.exports = exports;
